import { ArrowUpRight, Building2, GraduationCap } from "lucide-react";
import { CONTACT_EMAIL } from "@/lib/data";

export const Pros = () => (
  <section className="py-20 md:py-24 bg-[#FFF3B0]/50 border-y-2 border-black" data-testid="pros-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <span className="font-sans text-sm font-bold tracking-[0.25em] uppercase text-[#FF6B6B]">
            Pour les pros
          </span>
          <h2 className="mt-3 font-display text-5xl md:text-6xl leading-none uppercase">
            Écoles & <br />
            <span className="italic">entreprises.</span>
          </h2>
          <p className="mt-5 text-lg text-[#1a1a1a] leading-relaxed max-w-md">
            Interventions sur mesure pour établissements scolaires, collèges, lycées, universités et entreprises. Un format taillé pour vos besoins.
          </p>
        </div>

        <div className="lg:col-span-7 bg-white border-2 border-black rounded-3xl p-7 md:p-10 shadow-brutal">
          <div className="grid sm:grid-cols-2 gap-6">
            <div className="flex gap-3">
              <GraduationCap size={24} className="shrink-0 mt-1" />
              <div>
                <h3 className="font-display text-2xl uppercase leading-tight">Milieu scolaire</h3>
                <p className="mt-1 text-sm text-[#3a3a3a] leading-relaxed">
                  Expression corporelle, improvisation, créativité collective. Format atelier ponctuel ou cycle annuel.
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <Building2 size={24} className="shrink-0 mt-1" />
              <div>
                <h3 className="font-display text-2xl uppercase leading-tight">Entreprise</h3>
                <p className="mt-1 text-sm text-[#3a3a3a] leading-relaxed">
                  Cohésion d'équipe, gestion du stress, prise de parole, team building créatif.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-4">
            <a
              href={`mailto:${CONTACT_EMAIL}?subject=Demande%20de%20devis%20-%20Atelier%20scolaire%20ou%20entreprise`}
              data-testid="pros-cta"
              className="inline-flex items-center gap-2 bg-black text-white rounded-full px-6 py-3 font-sans font-bold hover:-translate-y-1 transition-transform"
            >
              Demander un devis
              <ArrowUpRight size={18} />
            </a>
            <span className="font-sans text-sm text-[#3a3a3a]">Devis personnalisé sous 48h</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
